import { useOnboardingClient } from 'api/requests';
import { useInterval } from 'hooks';
import { STATUS_UPDATE_INTERVAL } from 'modules/onboarding/common/constants';
import { ClientOnboardingStatusFeature } from 'modules/onboarding/common/feature';

import { useClientWithRepresentativeOnboardingStatus, useKyc } from '../hooks';
import { ClientWithRepresentativeView } from '../views';

interface Props {
  clientId: string;
}

export const ClientWithRepresentativeContainer = ({ clientId }: Props) => {
  const { expirationHandler, loading, token } = useKyc(clientId);

  const { currentClient, refetch: refetchClient } =
    useOnboardingClient(clientId);

  const onboardingStatus =
    useClientWithRepresentativeOnboardingStatus(currentClient);

  useInterval(
    () => {
      refetchClient();
    },
    onboardingStatus ? STATUS_UPDATE_INTERVAL : null
  );

  if (onboardingStatus) {
    return (
      <ClientOnboardingStatusFeature onboardingStatus={onboardingStatus} />
    );
  }

  return (
    <ClientWithRepresentativeView
      expirationHandler={expirationHandler}
      loading={loading}
      token={token}
    />
  );
};
